import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { SplashComponent } from '../splash/splash.component';
import { HeaderComponent } from '../header/header.component';
// import { TextMetric } from '../textmetric/text-metric';
import { DataStore, FileSaver } from '../utils/utils';
import { DashboardDataUtility } from '../utils/data.calculate';
import { LogoutComponent } from '../logout/logout.component';
import { LogoutSSOComponent } from '../logout/logoutsso.component';
import { LoginComponent, DashboardHome, StatusReportComponent, ExperienceReportComponent, VideoDetailsComponent, SSOLoginComponent } from './views';
import { TableView } from '../datawarehousetable/tableView';
import { GraphView } from '../datawarehousegraph/graphView';
import { ChartsModule } from '../charts/charts.module';
import { DatepickerModule, DropdownModule } from 'ng2-bootstrap/ng2-bootstrap';

import { MyDateRangePickerModule } from 'mydaterangepicker';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ChartsModule,
        DatepickerModule,
        DropdownModule,
        MyDateRangePickerModule
        // messagesDashRouting
    ],
    declarations: [
        SplashComponent,
        HeaderComponent,
        // TextMetric,
        LogoutComponent,
        LogoutSSOComponent,
        LoginComponent,
        SSOLoginComponent,
        DashboardHome,
        TableView,
        GraphView,
        StatusReportComponent,
        ExperienceReportComponent,
        VideoDetailsComponent
    ],
    exports: [
        SplashComponent,
        HeaderComponent,
        // TextMetric,
        LogoutComponent,
        LoginComponent,
        SSOLoginComponent,
        DashboardHome,
        StatusReportComponent,
        ExperienceReportComponent,
        VideoDetailsComponent
    ],
    providers: [DataStore, FileSaver, DashboardDataUtility]
})
export class ViewsModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewsmodule/views.module.ts